<template>
    <command-palette-dialog v-if="visible" @close="visible = false" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useEventListener } from '@vueuse/core';
import CommandPaletteDialog from '~/components/command-palette/CommandPaletteDialog.vue';

const visible = ref(false);

useEventListener(window, 'keydown', (event: KeyboardEvent) => {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
        event.preventDefault();
        visible.value = !visible.value;
    }
});
</script>
